import axios from 'axios';

import {
  requestInterceptor,
  requestErrorInterceptor,
} from '../interceptors/requestInterceptors';

import {
  responseInterceptor,
  responseErrorInterceptor,
} from '../interceptors/responseInterceptors';

const baseURL = import.meta.env.VITE_MULTITRANSACTION_URL;

const multiTransactionAxiosInstance = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
    // Origin: 'global66.com',
  },
});

multiTransactionAxiosInstance.interceptors.request.use(
  (config) => requestInterceptor(config),
  requestErrorInterceptor
);
multiTransactionAxiosInstance.interceptors.response.use(
  responseInterceptor,
  responseErrorInterceptor
);

export { multiTransactionAxiosInstance };
